import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import Logo from "../assets/images/Logo.svg";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#FAF8F5",
        py: 6,
        mt: 8,
        borderTop: "1px solid #E5E5E5",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Brand */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ display: "flex", aligs: "center", gap: 1, mb: 2 }}>
              <img
                src={Logo}
                alt="HappyPaws Logo"
                style={{ width: "205px", height: "45px" }}
              />
            </Box>
          </Grid>

          {/* About HappyPaws Links */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Typography
              variant="h6"
              sx={{
                color: "#178B8E",
                fontWeight: 700,
                mb: 2,
                fontSize: "1.1rem",
              }}
            >
              About HappyPaws
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#5A5A5A",
                  "&:hover": { color: "#178B8E" },
                  transition: "color 0.2s",
                }}
              >
                About Us
              </Link>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#5A5A5A",
                  "&:hover": { color: "#178B8E" },
                  transition: "color 0.2s",
                }}
              >
                Contact Us
              </Link>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#5A5A5A",
                  "&:hover": { color: "#178B8E" },
                  transition: "color 0.2s",
                }}
              >
                Terms of Service
              </Link>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#5A5A5A",
                  "&:hover": { color: "#178B8E" },
                  transition: "color 0.2s",
                }}
              >
                Privacy Policy
              </Link>
            </Box>
          </Grid>

          {/* Need Help Links */}
          <Grid size={{ sm: 6, md: 4 }}>
            <Typography
              variant="h6"
              sx={{
                color: "#178B8E",
                fontWeight: 700,
                mb: 2,
                fontSize: "1.1rem",
              }}
            >
              Need help?
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#5A5A5A",
                  "&:hover": { color: "#178B8E" },
                  transition: "color 0.2s",
                }}
              >
                Help Center
              </Link>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #E5E5E5" }}>
          <Typography variant="body2" align="center" sx={{ color: "#5A5A5A" }}>
            © {new Date().getFullYear()} HappyPaws. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
